export interface AuditorMember {
  id: number;
  name: string;
}
